import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './CreatePostingMutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateTextPostingMutationVariables = Types.Exact<{
  actorGlobalId: Types.Scalars['GlobalID']['input'];
  audience?: Types.InputMaybe<Array<Types.Scalars['GlobalID']['input']> | Types.Scalars['GlobalID']['input']>;
  comment: Types.Scalars['String']['input'];
  commentArticleV1?: Types.InputMaybe<Array<Types.ArticlesCreateArticleBlocksInput> | Types.ArticlesCreateArticleBlocksInput>;
  images?: Types.InputMaybe<Array<Types.PostingsCreateImageAttachmentInput> | Types.PostingsCreateImageAttachmentInput>;
  links?: Types.InputMaybe<Array<Types.PostingsCreateLinkAttachmentInput> | Types.PostingsCreateLinkAttachmentInput>;
  publicationStrategy?: Types.InputMaybe<Types.PostingPublicationStrategy>;
  publishAt?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  videos?: Types.InputMaybe<Array<Types.PostingsCreateVideoAttachmentInput> | Types.PostingsCreateVideoAttachmentInput>;
  visibility?: Types.InputMaybe<Types.PostingsVisibility>;
}>;


export type CreateTextPostingMutation = (
  { __typename?: 'Mutation' }
  & { postingsCreatePosting?: Types.Maybe<(
    { __typename?: 'PostingsPostingMutationResult' }
    & { success?: Types.Maybe<(
      { __typename?: 'PostingsPosting' }
      & Pick<Types.PostingsPosting, 'id' | 'actorGlobalId' | 'comment' | 'activityId'>
    )>, error?: Types.Maybe<(
      { __typename?: 'PostingsError' }
      & Pick<Types.PostingsError, 'message' | 'details'>
    )> }
  )> }
);


export type CreateTextPostingMutationFn = Apollo.MutationFunction<CreateTextPostingMutation, CreateTextPostingMutationVariables>;

/**
 * __useCreateTextPostingMutation__
 *
 * To run a mutation, you first call `useCreateTextPostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTextPostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTextPostingMutation, { data, loading, error }] = useCreateTextPostingMutation({
 *   variables: {
 *      actorGlobalId: // value for 'actorGlobalId'
 *      audience: // value for 'audience'
 *      comment: // value for 'comment'
 *      commentArticleV1: // value for 'commentArticleV1'
 *      images: // value for 'images'
 *      links: // value for 'links'
 *      publicationStrategy: // value for 'publicationStrategy'
 *      publishAt: // value for 'publishAt'
 *      videos: // value for 'videos'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useCreateTextPostingMutation(baseOptions?: Apollo.MutationHookOptions<CreateTextPostingMutation, CreateTextPostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTextPostingMutation, CreateTextPostingMutationVariables>(Operations.CreateTextPosting, options);
      }
export type CreateTextPostingMutationHookResult = ReturnType<typeof useCreateTextPostingMutation>;
export type CreateTextPostingMutationResult = Apollo.MutationResult<CreateTextPostingMutation>;
export type CreateTextPostingMutationOptions = Apollo.BaseMutationOptions<CreateTextPostingMutation, CreateTextPostingMutationVariables>;